import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-company-breadcrum',
    templateUrl: './company-breadcrum.component.html',
    styleUrls: ['./company-breadcrum.component.scss'],
    standalone: false
})
export class CompanyBreadcrumComponent implements OnInit {

  constructor(public sharedService:SharedService) { }

  ngOnInit() {
  }

}
